var d = (p, m, o) => new Promise((t, a) => {
  var n = (e) => {
    try {
      s(o.next(e));
    } catch (r) {
      a(r);
    }
  }, i = (e) => {
    try {
      s(o.throw(e));
    } catch (r) {
      a(r);
    }
  }, s = (e) => e.done ? t(e.value) : Promise.resolve(e.value).then(n, i);
  s((o = o.apply(p, m)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import C from "./relatedApproval.ce.vue.js";
import { defineComponent as _, useTemplateRef as h, openBlock as y, createBlock as v, withCtx as c, createVNode as f } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as I } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as l } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import x from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import N from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const H = /* @__PURE__ */ _({
  __name: "index.ce",
  setup(p, { expose: m }) {
    const o = h("relatedApprovalRefs");
    let t = null;
    const a = I(), n = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, i = (e) => d(this, null, function* () {
      var r;
      return (r = o.value) == null || r.open({
        selectMode: e.selectMode || "",
        businessId: e.businessId || "",
        isCreatorId: e.isCreatorId || !1,
        orderId: e.orderId || ""
      }), new Promise((u) => {
        t = u;
      });
    }), s = (e) => {
      t && (t(e), t = null);
    };
    return m({ open: i }), (e, r) => (y(), v(l(N), {
      locale: l(R),
      "date-locale": l(x),
      "theme-overrides": n,
      "style-mount-target": l(a)
    }, {
      default: c(() => [
        f(l(P), null, {
          default: c(() => [
            f(C, {
              ref_key: "relatedApprovalRefs",
              ref: o,
              onSubmit: s
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"]));
  }
});
export {
  H as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/related-approval/index.ce.vue2.js
// module id = 1283
// module chunks = 41